import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild, AfterViewChecked, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InfoService } from '@app/core/info/info.service';
import { ISigningTextsInterface, SigningTexts, ISigningValuesInterface, ISigningValuesDefaultsInterface } from '@app/certificates/signing/signing';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SigningService } from '@app/certificates/signing/signing.service';
import { takeUntil, first } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ICertificateData, PackType } from '@app/certificates/manage/manage';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { cadesValues } from '@app/certificates/signing/signing.values';
import { pdfValues } from '@app/certificates/signing/signing.values';
import { xmlValues } from '@app/certificates/signing/signing.values';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { EmergencyService } from '@app/core/auth/component/emergency-login/emergency-login.service';
import { ProfileRemainingCountComponent } from '@app/profile/profile-remaining-count/profile-remaining-count.component';
import { ProfileService } from '@app/core/services/profile/profile.service';
import { SearchUserIdentifiers, SearchUserRequestParams } from '@app/profile/settings/settings';
import { SessionStorageService, selectorAuth } from '@app/core';
import { IUserData } from '@app/profile/main/details';
import { BusinessService } from '../../business.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { BusinessFileSettingsComponent } from '../../business-file-settings/business-file-settings.component';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgFor } from '@angular/common';
import { IFileData, IParcelSequenceData, IParcelSignContext, ISignRequestData, ParcelType } from '../../business-models';
import * as mime from 'mime-types';
import { VisualSignaturePositionComponent } from '../../visual-signature-position/visual-signature-position.component';
import { ConfirmComponent } from '@app/core/info/confirm/confirm.component';
import { IConfirmData } from '@app/core/info/confirm/confirm';
import { customMaxLengthValidator } from '@app/shared/validator-functions/custom-max-length-validator';
import { getErrorMsgFromControl } from '@app/shared/helpers/get-error-msg-from-control-helper';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'cloud-parcel-signing',
  templateUrl: './parcel-signing.component.html',
  styleUrls: ['./parcel-signing.component.scss']
})
export class ParcelSigningComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild(ProfileRemainingCountComponent) remainingCountComponent: ProfileRemainingCountComponent;
  @ViewChild('fileDropRef') fileDropEl: ElementRef;
  readonly dateTimeFormat = environment.dateTimeFormat;
  readonly expirationTime = environment.signedDocExpirationTime;

  fileForm: FormGroup;
  file: File;
  signTypeForm: FormGroup;
  texts: ISigningTextsInterface = new SigningTexts();
  values: ISigningValuesInterface;
  unsubscribe$: Subject<void> = new Subject<void>();
  selectedCert: ICertificateData;
  files: IFileData[] = [];
  disabled = false;
  loading: boolean;
  isEditable = true;
  isSentSuccessfully: boolean;
  signedfileName: string;
  private _signDocReqId: string;
  private i18nTexts = 'signingTexts';
  isCertInvalid: boolean;
  notDownloadedDocuments = false;
  validCertificates = true;
  downloads = [];
  certs: ICertificateData[] = new Array();
  padesTypes = pdfValues.signType;
  cadesTypes = cadesValues.signType;
  xadesTypes = xmlValues.signType
  signingCancelled: boolean;
  signingStepCompleted = false;
  otherSigner = false;
  userIdentifier: string;
  userIdentifierCc: string;
  searchOptions: SearchUserRequestParams;
  otherSignerCertReqId = '';
  userData: IUserData;
  sendSuccess: boolean;
  users = [];
  usersInCopy = [];
  companyData: any;
  businessAccountId;
  groups = [];
  employeeGroups = [];
  receiversListIdToSend = null;
  receiversList = [];
  signCount: number;
  packId: string;
  loadingResend = true;
  loadingNames = true;
  maxSingleSize = environment.maxUploadSize; // 20MB
  maxTotalSize = environment.maxRequestSize; // 50MB
  maxFileCount = 10;

  groupIdsForm = new FormGroup({
    groupIds: new FormControl([])
  });
  packageNameControl = new FormControl('', [Validators.required, customMaxLengthValidator(100)]);
  errMessagesForPackageNameControl = { maxlength: 'validationTexts.maxLengthPackageName', required: 'validationTexts.requiredField'}
  packageNameControlErrMsg$ = getErrorMsgFromControl(this.packageNameControl, this.errMessagesForPackageNameControl);

  packageDescriptionControl = new FormControl('', [Validators.required, customMaxLengthValidator(250)]);
  errMessagesForPackageDescriptionControl = { maxlength: 'validationTexts.maxLengthPackageDescription', required: 'validationTexts.requiredField'}
  packageDescriptionControlErrMsg$ = getErrorMsgFromControl(this.packageDescriptionControl, this.errMessagesForPackageDescriptionControl);
  hasDefaultName = false;
  hasDefaultDescription = false;
  showValidations = false;
  packageToArchive = true;
  packageAvailable = true;
  recepientPays = false;
  receiversListName;
  selectedListId;
  loadedLists = false;
  groupIdToSend = null;
  isRegistered = false;
  loadingList = false;
  savingList = false;
  sendWithoutGroups: boolean = false;

  periodsDictionary = [
    { key: '1', unit: 'hour', value: 60 },
    { key: '2', unit: 'hour', value: 120 },
    { key: '4', unit: 'hour', value: 240 },
    { key: '8', unit: 'hour', value: 480 },
    { key: '1', unit: 'day', value: 1440 },
    { key: '2', unit: 'day', value: 2880 },
    { key: '3', unit: 'day', value: 4320 },
    { key: '4', unit: 'day', value: 5760 },
    { key: '5', unit: 'day', value: 7200 },
    { key: '6', unit: 'day', value: 8640 },
    { key: '7', unit: 'day', value: 10080 }
  ];

  validity = 10080;
  reminder = 1440;

  isResend = false;
  names = [];
  copiedNames = [];
  visibleSignature = true;

  private pageDialog: MatDialogRef<BusinessFileSettingsComponent>;
  private signatureDialog: MatDialogRef<VisualSignaturePositionComponent>;
  private confirmDialog: MatDialogRef<ConfirmComponent>;

  constructor(
    public info: InfoService,
    private signingService: SigningService,
    private translateService: TranslateService,
    private sessionStorageService: SessionStorageService,
    private businessService: BusinessService,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    private store: Store<any>,
    private router: Router,
    private emergency: EmergencyService,
    private profileService: ProfileService,
    private dialog: MatDialog
  ) {
    if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras?.state) {
      this.isResend = true;
      this.groupIdsForm = new FormGroup({
        groupIds: new FormControl({ value: [], disabled: true })
      });
      this.packId = this.router.getCurrentNavigation().extras.state.requestedId;
      this.signCount = this.router.getCurrentNavigation().extras.state.signCount;
      this.loadResendPackData(this.packId);
    } else {
      this.loadingResend = false;
      this.loadingNames = false;
    }
    if (this.emergency.getEmergencyState()) {
      this.router.navigate(['/manage/manage']);
    }
    this.loadTranslations();
    this.store
      .select(selectorAuth)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res.userData) { this.userData = res.userData; }
      });
  }

  ngOnInit() {
    this.signingCancelled = false;
    this.info.dismissAll();
    this.getCurrentLoggedInAccount();
    this.getCompanyData();
  }

  loadResendPackData(requestId) {
    this.businessService.getRequestsHistoryDetails(requestId).subscribe(res => {
      if (res.data) {
        this.setResendData(res.data);
        let ids = res.data.sequenceDetails.map(d => d.cmrId);
        this.businessService.getRecipientsNames(ids).subscribe(res => {
          this.names = res.data;
          this.loadingResend = false;
        });
        this.businessService.getRecipientsNames(res.data.ccCmrId).subscribe(res => {
          this.copiedNames = res.data;
          this.loadingNames = false;
        });
      }
    });
  }

  checkLoadedResend() {
    return !this.loadingResend && !this.loadingNames;
  }

  setResendData(data) {
    this.packageNameControl.setValue(data.name);
    this.packageNameControl.disable();
    this.packageDescriptionControl.setValue(data.description);
    this.packageDescriptionControl.disable();
    data.sequenceDetails[0].documentDetails.forEach(file => {
      this.setResendFileEntry(file);
    })
    this.users = data.sequenceDetails;
    this.usersInCopy = data.ccCmrId;
    this.groupIdsForm.get('groupIds').setValue(data.companyGroupId);
  }

  setResendFileEntry(fileInResend) {
    let fileEntry: IFileData = {
      file: null,
      fileName: fileInResend.filename,
      data: '',
      confirmText: 'Doc to sign: ' + fileInResend.filename,
      hashAlgorithm: fileInResend.hashAlgorithm,
      signatureType: fileInResend.signatureType,
      contentFormat: 'BINARY_BASE64',
      toBeArchived: true,
      padesVisualSignature: mime.lookup(fileInResend.filename) == 'application/pdf' ? true : false,
      signaturePosition: fileInResend.signaturePosition,
      contentType: 'PARCEL_DOCUMENT',
      signable: true,
      previewRequired: false
    };

    this.signingService.getFileForPreview(fileInResend.usageId).subscribe(res => {
      let received = new File([res.body], fileInResend.filename, { type: mime.lookup(fileInResend.filename) });
      fileEntry.file = received;
      this.files.push(fileEntry);
      this.getBase64(fileEntry);
    })
  }

  getCurrentLoggedInAccount() {
    this.businessAccountId = this.sessionStorageService.getItem("businessAccountId");
  }

  getCompanyData() {
    this.businessService.getCompany(this.businessAccountId).subscribe(res => {
      this.companyData = res.data;
      this.getReceiversList();
      this.isRegistered = this.companyData.services.length && this.companyData.services.find(service => service['serviceType'] === ParcelType.BATCH_SIGNING);
      this.getGroups();
    })
  }

  getGroups() {
    this.businessService.getCompanyGroups(this.companyData.cmrId).subscribe(res => {
        this.groups = res.groups;
      });
    this.businessService.getEmployeeCompanyGroups(this.userData.cmrId, this.businessAccountId).subscribe(res => {
      this.employeeGroups = res.groups;
      const groupIds = this.employeeGroups.map(group => group.id);
      this.groupIdsForm.get('groupIds').setValue(groupIds);
    });
  }

  getReceiversList() {
    this.businessService.getReceiversLists(this.companyData.cmrId, this.userData.cmrId).subscribe(res => {
      this.loadedLists = true;
      if (res) {
        this.receiversList = res.data;
      }
    });
  }

  addReceiversList() {
    if (!this.users.length) {
      this.info.error('businessTexts.noUsers');
      return;
    }
    if (!this.receiversListName) {
      this.info.error('businessTexts.noListName');
      return;
    }

    let found = this.receiversList.find(list =>
      list.name == this.receiversListName
    );

    if (found) {
      this.openReSaveConfirmDialog(found);
    } else {
      this.savingList = true;
      let cmrIds = [];
      this.users.forEach(user => {
        cmrIds.push(user.cmrId);
      })
      this.businessService.saveReceiversList({
        name: this.receiversListName, 
        companyCmrId: this.companyData.cmrId,
        employeeCmrId: this.userData.cmrId,
        cmrIds: cmrIds
      }).subscribe(res => {
        if (res.status === 200) {
          this.info.success('businessTexts.receiversListAddSuccess');
          this.getReceiversList();
        } else {
          this.info.error('signingTexts.signingError');
        }
        this.savingList = false;
      });
    }
  }

  openReSaveConfirmDialog(group) {
    this.confirmDialog = this.dialog.open(
      ConfirmComponent,
      {
        data: {
          title: this.translateService.instant('businessTexts.dialogTexts.overrideReceiversGroupTitle'),
          question: this.translateService.instant('businessTexts.dialogTexts.overrideReceiversGroupQuestion', { group: group.name }),
          confirmTxt: this.translateService.instant('settingsList.common.confirm'),
          cancelTxt: this.translateService.instant('settingsList.common.cancel'),
          confirmAction: () => this.overrideReceiversGroup(group)
        } as IConfirmData
      });
  }

  overrideReceiversGroup(group) {
    this.savingList = true;

    let cmrIds = [];
    this.users.forEach(user => {
      cmrIds.push(user.cmrId);
    })

    this.businessService.updateReceiversList({
      name: this.receiversListName,
      companyCmrId: this.companyData.cmrId, 
      employeeCmrId: this.userData.cmrId,
      recipientListId: group.id, 
      cmrIds: cmrIds
    }).subscribe(res => {
      if (res.status === 200) {
        this.info.success('businessTexts.receiversListSaveSuccess');
        this.getReceiversList();
      } else {
        this.info.error('signingTexts.signingError');
      }
      this.savingList = false;
    });

    this.confirmDialog.close();
  }

  getSenderName(lang) {
    return lang == 'bg' ? this.userData.firstName.bg + ' ' + this.userData.lastName.bg : this.userData.firstName.en + ' ' + this.userData.lastName.en;
  }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }


  calculateExpiryDate(date) {
    return date.setDate(date.getDate() + this.expirationTime);
  }

  isIE() {
    const match = navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/);
    let isIE = false;
    if (match !== -1) {
      isIE = true;
    }
    return isIE;
  }

  onCertSelected(cert: ICertificateData) {
    this.info.dismissAll();
    this.selectedCert = cert;
    if (cert.deviceIds.length === 0) {
      this.isCertInvalid = true;
      this.info.warning('manageTexts.noDevices');
    }
    if (cert.remainingCount === 0 && cert.packType === PackType.PREPAID) {
      this.isCertInvalid = true;
      this.info.warning('manageTexts.noRemainingCounts');
    } else {
      this.isCertInvalid = false;
    }
  }

  onFileChanged(event) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      if (file.size > environment.maxUploadSize) {
        this.file = null;
        this.info.error('signingTexts.info.fileSizeExceeded');
        this.fileForm.reset();
      } else {
        this.file = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {

          this.signingService.values(file.name.split('.').pop())
            .pipe(
              first(),
              takeUntil(this.unsubscribe$)
            )
            .subscribe(v => this.initTypeForm(v));
          this.fileForm.patchValue({
            file: reader.result
          });
          // need to run CD since file load runs outside of zone
          // this.cd.markForCheck();
          this.cd.detectChanges();
        };
      }
    }
  }

  hasNoFile() {
    return this.file ? false : true;
  }

  private initFileForm() {
    this.fileForm = this.formBuilder.group({
      file: [null, Validators.required]
    });
  }

  private initTypeForm(values: ISigningValuesInterface) {
    this.values = values;

    this.signTypeForm = this.formBuilder.group({
      signFormat: [values.defaults.signFormat, Validators.required],
      signLevel: [values.defaults.signLevel, Validators.required],
      signType: [values.defaults.signType, Validators.required],
      signHashAlg: [values.defaults.signHashAlg, Validators.required],
      notToBeArchived: [false, Validators.required],
      visibleSignature: [true, Validators.required],
      isRpPaying: [true, Validators.required]
    });
  }

  private loadTranslations(): void {
    this.translateService.stream([this.i18nTexts], {})
      .subscribe((texts: any) => {
        [this.texts] = [texts[this.i18nTexts]];
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  setTypes() {
    if (this.signTypeForm.value.signFormat === 'PAdES') {
      this.values.signType = this.padesTypes;
    }
    if (this.signTypeForm.value.signFormat === 'XAdES') {
      this.values.signType = this.xadesTypes;
    }
    if (this.signTypeForm.value.signFormat === 'CAdES') {
      this.values.signType = this.cadesTypes;
    }
    this.signTypeForm.controls['signType'].setValue(this.values.signType[0].value);
  }


  addSelf(type?: string) {
    this.findUser(this.userData.personalId, type);
  }

  searchUser(type?: string) {
    const identifier = type ? this.userIdentifierCc : this.userIdentifier;
    if (identifier) {
      this.findUser(identifier, type);
    }
  }


  private findUser(localUserIdentifier: string, type?: string) {
    this.info.dismissAll();
    if (localUserIdentifier) {
      const identifierType = this.determineIdentifierType(localUserIdentifier);
      if (identifierType) {
        this.searchOptions = {};
        this.searchOptions[identifierType] = localUserIdentifier;
        if (type === 'copy') {
          this.searchOptions["isCopy"] = true;
          this.searchOptions["companyCmrId"] = this.companyData.cmrId;
        }
        if (identifierType === SearchUserIdentifiers.phoneNumber) {
          this.searchOptions[identifierType] = encodeURIComponent(localUserIdentifier);
        }
        this.profileService.searchUser(this.searchOptions).subscribe(res => {
          if (res.status === 404) {
            this.info.error('signingTexts.noUserFound');
          }
          if (res.status === 400) {
            this.info.error(res.message);
          }
          if (res.status === 200 && res.data) {
            this.addSigner(res.data, type);
          }
        });
      } else {
        this.info.error('signingTexts.invalidIdentifier');
      }
      this.clearText();
    }
  }

  addSigner(user, type?) {
    if (!type) {
      if (!this.users.find(u => u.cmrId == user.cmrId)) {
        if (!this.usersInCopy.find(u => u.cmrId == user.cmrId)) {
          this.users.push(user);
        } else {
          this.info.error('businessTexts.userAlreadyInCopy');
        }
      }
    } else {
      if (!this.usersInCopy.find(u => u.cmrId == user.cmrId)) {
        if (!this.users.find(u => u.cmrId == user.cmrId)) {
          this.usersInCopy.push(user);
        } else {
          this.info.error('businessTexts.userAlreadyInReceivers');
        }
      }
    }
  }

  removeSigner(id) {
    const index = this.users.findIndex(u => u.cmrId == id);
    if (index !== -1) {
      this.users.splice(index, 1);
    }
  }

  removeSignerCc(id) {
    const index = this.usersInCopy.findIndex(u => u.cmrId == id);
    if (index !== -1) {
      this.usersInCopy.splice(index, 1);
    }
  }
  determineIdentifierType(userIdentifier: string) {
    let type;
    const emailPattern = new RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$');
    const phonePattern = new RegExp('[+]{1}[0-9]+$');
    const idPattern = new RegExp('^[0-9]+$');
    if (emailPattern.test(userIdentifier)) {
      type = SearchUserIdentifiers.email;
    }
    if (phonePattern.test(userIdentifier)) {
      type = SearchUserIdentifiers.phoneNumber;
    }
    if (idPattern.test(userIdentifier)) {
      type = SearchUserIdentifiers.personalId;
    }
    return type;
  }

  clearText() {
    this.userIdentifier = '';
    this.otherSignerCertReqId = '';
    this.userIdentifierCc = '';
  }

  formatName(fullName) {
    // Split the name by spaces and filter out any empty parts
    let nameParts = fullName.split(' ').filter(part => part.trim() !== '');
    // Join the first and last name (first and last element of the array)
    if (nameParts.length > 1) {
      return `${nameParts[0]} ${nameParts[nameParts.length - 1]}`;
    } else {
      return fullName;  // If only one name is found, return the original name
    }
  }

  displayUserName(cmrId) {
    if (this.isResend) {
      if (this.names.length) {
        let person = this.names.find((obj) => obj.id == cmrId);
        let nameBg = this.formatName(person.nameBg);
        let nameEn = this.formatName(person.nameEn);
        return this.translateService.currentLang == 'bg' ? nameBg : nameEn;
      }
    } else {
      const currentUser = this.users.find(u => u.cmrId == cmrId);
      return this.translateService.currentLang == 'bg' ? currentUser.firstName.bg + ' ' + currentUser.lastName.bg :
        currentUser.firstName.en + ' ' + currentUser.lastName.en;
    }
  }

  displayUserCcName(cmrId) {
    if (this.isResend) {
      if (this.copiedNames.length) {
        let person = this.copiedNames.find((obj) => obj.id == cmrId);
        let nameBg = this.formatName(person.nameBg);
        let nameEn = this.formatName(person.nameEn);
        return this.translateService.currentLang == 'bg' ? nameBg : nameEn;
      }
    } else {
      const currentUser = this.usersInCopy.find(u => u.cmrId === cmrId.cmrId);
      return this.translateService.currentLang == 'bg' ? currentUser.firstName.bg + ' ' + currentUser.lastName.bg :
        currentUser.firstName.en + ' ' + currentUser.lastName.en;
    }
  }

  displayToBeArchivedCheckbox() {
    return environment.displayToBeArchivedCheckbox;
  }

  onSelectPeriod(p) {
    this.validity = p;
  }

  onSelectReminderPeriod(p) {
    this.reminder = p;
  }

  getUnitTranslation(p, unit) {
    return this.translateService.instant(p == 1 ? 'settingsList.' + unit : 'settingsList.' + unit + 's');
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  onSelectGroup(groupId) {
    this.groupIdToSend = groupId;
  }

  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    if (this.files.length == 0) {
      this.clearDefaultNameAndDescription();
    }
    let list = new DataTransfer();
    let clearFileList = list.files;
    this.fileDropEl.nativeElement.files = clearFileList;
  }

  prepareFilesList(files: Array<any>) {
    Array.from(files).forEach(file => {
      let isComplient = this.checkFileLimitations(file);
      if (isComplient) {
        this.files.push(this.initFileEntry(file));
        if (this.files.length != 1) {
          this.clearDefaultNameAndDescription();
        }
      }
    })
    this.fileDropEl.nativeElement.value = '';
  }

  checkFileLimitations(file) {
    let isComplient = true;
    let totalSize = 0;
    this.files.forEach(file => {
      totalSize += file.file.size;
    })

    if (file.size > this.maxSingleSize) {
      isComplient = false;
      this.info.error('businessTexts.fileLimit');
    }
    if (this.files.length >= this.maxFileCount) {
      isComplient = false;
      this.info.error('businessTexts.fileNumberLimit');
    }
    if (totalSize + file.size > this.maxTotalSize) {
      isComplient = false;
      this.info.error('businessTexts.totalFileLimit');
    }
    let found = this.files.find(f =>
      f.fileName == file.name
    );
    if (found) {
      isComplient = false;
      this.info.error('businessTexts.alreadyUploadedFile');
    }
    return isComplient;
  }

  initFileEntry(file) {
    let signDefaults: ISigningValuesDefaultsInterface;
    this.signingService.values(file.name.split('.').pop()).subscribe(values => {
      signDefaults = values.defaults;
    })

    let fileEntry: IFileData = {
      file: file,
      fileName: file.name,
      data: '',
      confirmText: 'Doc to sign: ' + file.name,
      hashAlgorithm: signDefaults.signHashAlg,
      signatureType: this.getSignatureTypesValue(signDefaults),
      contentFormat: 'BINARY_BASE64',
      toBeArchived: true,
      padesVisualSignature: file.type == 'application/pdf' ? true : false,
      signaturePosition: null,
      contentType: 'PARCEL_DOCUMENT',
      signable: true,
      previewRequired: false
    };
    this.getBase64(fileEntry);
    return fileEntry;
  }

  getSignatureTypesValue(signDefaults) {
    if (signDefaults.signFormat.toUpperCase() === 'PADES') {
      return signDefaults.signFormat.toUpperCase() + '_' + signDefaults.signLevel.toUpperCase();
    } else {
      return signDefaults.signFormat.toUpperCase() === 'CADES' && signDefaults.signType.toUpperCase() === 'ENVELOPING' ? 'CADES_' + signDefaults.signLevel.toUpperCase() + '_ATACHED'
        : signDefaults.signFormat.toUpperCase() + '_' + signDefaults.signLevel.toUpperCase() + '_' +
        signDefaults.signType.toUpperCase();
    }
  }


  viewFile(f) {
    const file = new Blob([f], { type: f.type });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  openSettings(file) {
    this.openSettingsDialog(file);
  }

  onSelectReceiversList() {
    if (this.selectedListId) {
      this.loadingList = true;
      this.businessService.getReceiversList(this.selectedListId).subscribe(res => {
        if (res) {
          let listUsers = res.data;
          listUsers.forEach(u => {
            let userToAdd = { cmrId: u.cmrId, firstName: { bg: u.firstNameBg, en: u.firstNameEn }, lastName: { bg: u.lastNameBg, en: u.lastNameEn } }
            if (!this.users.find(u => u.cmrId == userToAdd.cmrId)) {
              this.users.push(userToAdd);
            }
          })
        }
        this.loadingList = false;
      });
    } else {
      this.info.error('businessTexts.firstSelectList');
    }
  }
    deleteReceiversList() {
    if (this.selectedListId) {
      const selectedList = this.receiversList.find(list => list.id === this.selectedListId);
      if (selectedList) {
        this.confirmDialog = this.dialog.open(
          ConfirmComponent,
          {
            data: {
              title: this.translateService.instant('businessTexts.dialogTexts.deleteReceiversListTitle'),
              question: this.translateService.instant('businessTexts.dialogTexts.deleteReceiversListQuestion', { list: selectedList.name }),
              confirmTxt: this.translateService.instant('settingsList.common.confirm'),
              cancelTxt: this.translateService.instant('settingsList.common.cancel'),
              confirmAction: () => this.performDeleteReceiversList()
            } as IConfirmData
          });
      } else {
        this.info.error('businessTexts.listNotFound');
      }
    } else {
      this.info.error('businessTexts.firstSelectList');
    }
  }

  performDeleteReceiversList() {
    this.loadingList = true;
    this.businessService.deleteReceiversList(this.userData.cmrId, this.companyData.cmrId, this.selectedListId).subscribe(res => {
      if (res.status === 200) {
        this.info.success('businessTexts.receiversListDeleteSuccess');
        this.selectedListId = null;
        this.getReceiversList();
      } else {
        this.info.error('signingTexts.signingError');
      }
      this.loadingList = false;
      this.confirmDialog.close();
    });
  }

  onCancel() {
    if (this.isResend) {
      this.router.navigate(['business/history']);
    } else {
      this.clearPackageData();
    }
  }

  clearPackageData() {
    this.isResend = false;
    this.users = [];
    this.usersInCopy = [];
    this.files = [];
    this.packageDescriptionControl.reset();
    this.packageDescriptionControl.setErrors(null);
    this.packageNameControl.reset();
    this.packageNameControl.setErrors(null);
    this.packageToArchive = true;
    this.packageAvailable = true;
    this.recepientPays = false;
    this.validity = 10080;
    this.showValidations = false;
    this.groupIdsForm.get('groupIds').setValue([]);
  }

  onSend() {
    this.checkSingleFilePackage();
    this.showValidations = true;
    this.packageDescriptionControl.markAsTouched();
    this.packageNameControl.markAsTouched();
    this.packageDescriptionControl.updateValueAndValidity();
    this.packageNameControl.updateValueAndValidity();

    let request = {
      signRequestData: this.getSignRequestData(),
      parcelSignContext: this.getParcelData(),
      parcelSignSequence: this.getSequenceData(),
      content: this.isRegistered ? this.getContent() : null,
      parcelId: this.isResend ? this.packId : null,
      parcelType: ParcelType.BATCH_SIGNING
    }

    if (this.isRegistered) {
      if (this.files.length && this.users.length && !this.packageNameControl.errors && !this.packageDescriptionControl.errors && this.hasSignableFile()) {
        this.stepper.selected.completed = true;
        this.stepper.next();
        this.loading = true;
        this.signingService.sendPackageForSigning(request).subscribe(res => {
          this.loading = false;
          if (res.status === 200) {
            this.isSentSuccessfully = true;
            this.info.success('businessTexts.packageSentSuccess');
          } else if (res.status === 400) {
            this.info.error(res.message);
          } else {
            this.info.error('signingTexts.signingError');
          }
        })
      }
    } else {
      this.info.error('businessTexts.notRegistered');
    }
  }

  hasSignableFile() {
    return this.files.find(f => f.signable);
  }


  checkSingleFilePackage() {
    if (this.files.length == 1) {
      let fileName = this.files[0].fileName.split('.').slice(0, -1).join('.');
      if (!this.packageDescriptionControl.touched) {
        this.packageDescriptionControl.setValue(fileName);
        this.hasDefaultDescription = true;
      }
      if (!this.packageNameControl.touched) {
        this.packageNameControl.setValue(fileName);
        this.hasDefaultName = true;
      }
    }
  }

  clearDefaultNameAndDescription() {
    if (this.hasDefaultDescription) {
      this.hasDefaultDescription = false;
      this.packageDescriptionControl.setValue('');
      this.packageDescriptionControl.reset();
      this.packageDescriptionControl.markAsUntouched();
      this.packageDescriptionControl.updateValueAndValidity();
    }
    if (this.hasDefaultName) {
      this.hasDefaultName = false;
      this.packageNameControl.setValue('');
      this.packageNameControl.reset();
      this.packageNameControl.markAsUntouched();
      this.packageNameControl.updateValueAndValidity();
    }
  }

  getSignRequestData() {
    let signRequestData: ISignRequestData = {
      companyCmrId: this.companyData.cmrId,
      companyNameBg: this.companyData.nameBg,
      companyNameEn: this.companyData.nameEn,
      senderCmrId: this.userData.cmrId,
      companyGroupId: this.sendWithoutGroups ? [] : this.groupIdsForm.value.groupIds,
      senderNameBg: this.getSenderName('bg'),
      senderNameEn: this.getSenderName('en'),
      ccCmrIdsAndEmails: this.createCmrIdEmailMap()
    };
    return signRequestData;
  }

  private createCmrIdEmailMap(): any {
    // Create a plain JavaScript object instead of a Map
    const cmrIdEmailObj = {};

    if (this.isResend) {
      this.usersInCopy.forEach((cmrId) => {
        cmrIdEmailObj[cmrId] = '';
      });
    } else {
      this.usersInCopy.forEach((user) => {
        cmrIdEmailObj[user.cmrId] = '';
      });
    }

    return cmrIdEmailObj;
  }

  getParcelData() {
    let parcelSignContext: IParcelSignContext = {
      name: this.packageNameControl.value,
      description: this.packageDescriptionControl.value,
      recipientPays: this.recepientPays,
      toBeArchived: this.packageToArchive,
      timestamp: new Date().getTime(),
      validityTimestamp: new Date().getTime() + this.validity * 60000, // minutes to miliseconds
      // reminderPeriod: this.reminder, // To be addded
      notAvailableAfterSigning: !this.packageAvailable,
      isLogin: false
    };
    return parcelSignContext;
  }

  getSequenceData() {
    let sequences: IParcelSequenceData[] = [];
    this.users.forEach((user, index) => {
      if (user.firstName && user.lastName) {
        let recipientNameBg = user.firstName.bg + ' ' + user.lastName.bg
        let recipientNameEn = user.firstName.en + ' ' + user.lastName.en
        sequences.push({ cmrId: user.cmrId, recipientNameBg: recipientNameBg, recipientNameEn: recipientNameEn, sequenceIndex: index + 1, recipientPersonalId: user.personalId })
      }
    })
    return sequences;
  }

  getContent() {
    const files = this.files.map((f) => {
      const copiedFile = Object.assign({}, f);
      delete copiedFile.file;
      delete copiedFile.index;
      if (!f.signable || !this.visibleSignature) {
        copiedFile.padesVisualSignature = false;
      }
      if (!f.signable || !this.visibleSignature || !f.signaturePosition) {
        delete copiedFile.signaturePosition;
      } else {
        copiedFile.signaturePosition = f.signaturePosition.map(({
          cmrId: cmrId,
          x: imageXAxis,
          y: imageYAxis,
          width: imageWidth,
          height: imageHeight,
          page: pageNumber
        }) => ({
          cmrId,
          imageXAxis,
          imageYAxis,
          imageWidth,
          imageHeight,
          pageNumber
        }));
      }
      if (copiedFile.signaturePosition) {
        // convert px to pints befor setting for sending
        copiedFile.signaturePosition.forEach(p => p.imageWidth = this.convertPxToPoints(p.imageWidth));
        copiedFile.signaturePosition.forEach(p => p.imageHeight = this.convertPxToPoints(p.imageHeight));
        copiedFile.signaturePosition.forEach(p => p.imageXAxis = this.convertPxToPoints(p.imageXAxis));
        copiedFile.signaturePosition.forEach(p => p.imageYAxis = this.convertPxToPoints(p.imageYAxis));
      }
      delete copiedFile.settings;
      return copiedFile;
    });

    return files;
  }

  convertPxToPoints(d) {
    if (Math.floor(d * 0.74999943307122) == 0) {
      return 1;
    }
    return Math.floor(d * 0.74999943307122);
  }

  openSettingsDialog(f) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      file: f.file,
      settings: f.settings ? f.settings : null
    };
    dialogConfig.panelClass = 'settings-panel-class';
    this.pageDialog = this.dialog.open(BusinessFileSettingsComponent, dialogConfig);

    const sub = this.pageDialog.componentInstance.close.subscribe((data: ISigningValuesDefaultsInterface) => {
      if (data) {
        f.settings = data;
        f.hashAlgorithm = data.signHashAlg;
        f.signatureType = data.signFormat.toUpperCase() === 'PADES' ?
          data.signFormat.toUpperCase() + '_' + data.signLevel.toUpperCase() :
          data.signFormat.toUpperCase() + '_' + data.signLevel.toUpperCase() +
          '_' + data.signType.toUpperCase();
      }
      this.pageDialog.close();
    });
  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.users, event.previousIndex, event.currentIndex);
  }

  getBase64(f) {
    const reader = new FileReader();
    reader.readAsDataURL(f.file);
    reader.onload = () => {
      f.data = reader.result.toString().split(',')[1];
    };
  }

  hasGroups() {
    return this.groupIdsForm.value.groupIds.length
  }

  checkSigned(i) {
    return i + 1 <= this.signCount;
  }

  checkResendCopied() {
    return !(this.isResend && this.usersInCopy.length == 0);
  }

  getTriggerMessage() {
    let message = '';
    if (this.groupIdsForm.value.groupIds.length == 1) {
      let id = this.groupIdsForm.value.groupIds[0];
      message = this.groups.find(group => group.id == id).name;
    }
    if (this.groupIdsForm.value.groupIds.length > 1) {
      let id = this.groupIdsForm.value.groupIds[0];
      message = this.groups.find(group => group.id == id).name + ' +' + (this.groupIdsForm.value.groupIds.length - 1) + ' ' + this.translateService.instant('businessTexts.others');
    }
    return message;
  }

  compareObjects(o1: any, o2: any) {
    if (typeof o1 === 'string' || typeof o1 === 'number') {
      return o1 === o2;
    }
    return o1.id == o2.id;
  }
  getGroupsTooltip() {
    let msg = '';
    if (this.hasGroups()) {
      msg = this.translateService.instant('businessTexts.accessGroup');
    } else {
      msg = this.translateService.instant('businessTexts.selectAccessGroup');
      if (this.isResend) {
        msg = '';
      }
    }

    if(this.groupIdsForm.value.groupIds.length && this.sendWithoutGroups) {
      return this.translateService.instant('businessTexts.sendWithoutGroups');
    }

    if (this.groupIdsForm.value.groupIds.length) {
      msg = '';
      this.groupIdsForm.value.groupIds.forEach(id => {
        msg += this.groups.find(g => g.id == id).name + '; ';
      })
    }
    return msg;
  }

  openPositionDialog(pdf, index) {
    pdf.index = index;
    this.openPositionPanel(pdf);
  }

  isPdf(f) {
    return f.file.type == 'application/pdf';
  }

  isSignable(f) {
    return this.visibleSignature && f.signable;
  }

  isMainPosButtonDisabled() {
    return !this.visibleSignature || !this.hasPdf();
  }

  hasPdf() {
    return this.files.find(f => f.file.type == 'application/pdf' && f.signable);
  }

  openPositionPanel(file?) {
    if (this.users.length) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.minWidth = '50%';
      dialogConfig.minHeight = 'calc(100vh - 90px)';
      dialogConfig.width = 'auto';
      dialogConfig.height = 'auto';
      let pdfs = []
      this.files.forEach((f, i) => {
        if (this.isPdf(f) && f.signable) {
          f.index = i
          pdfs.push(f);
        }
      })
      dialogConfig.data = {
        files: file ? [file] : pdfs,
        signers: this.users
      };
      dialogConfig.panelClass = 'position-panel-class';
      this.signatureDialog = this.dialog.open(VisualSignaturePositionComponent, dialogConfig);

      const sub = this.signatureDialog.componentInstance.close.subscribe((updatedFiles: any) => {
        if (updatedFiles) {
          updatedFiles.forEach(file => {
            this.files[file.index] = file;
          })
        }
        this.signatureDialog.close();
      });

    } else {
      this.info.error('businessTexts.noUsers');
    }
  }

  checkInstructions() {
    return !this.isResend && this.groupIdsForm.value.groupIds.length == 0;
  }

  sendWithoutGroupsChecked(event) {
    this.sendWithoutGroups = event.checked;
  }
}
